import { render, staticRenderFns } from "./SvgSmileEmoji.vue?vue&type=template&id=c461a680&"
import script from "./SvgSmileEmoji.vue?vue&type=script&lang=js&"
export * from "./SvgSmileEmoji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports